import { render, staticRenderFns } from "./MediaGroupMediaArchive.vue?vue&type=template&id=1fc2115f&"
import script from "./MediaGroupMediaArchive.vue?vue&type=script&lang=js&"
export * from "./MediaGroupMediaArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports